.assignmentPaper {
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	gap: 1rem;

	& .assignmentTitle {
		color: #42296e;
		font-weight: 600;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

.assignmentPanelContainer {
	display: flex;
	padding: 1rem 1.25rem 0 1rem;
	box-sizing: border-box;
	height: 100%;
	width: 100%;
}

.gradingSection {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	width: 100%;
}

.gradingContainer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
}

.gradingHeader {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;

	& .gradingTitle {
		color: #42296e;
		font-weight: 600;
		line-height: 1.5;
		font-size: 0.9375rem;
	}

	& .gradingDesc {
		color: #6b7280;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

.gradeInputContainer {
	display: flex;
	align-items: center;
	gap: 0.5rem;

	& .gradeInput {
		max-width: 75px;
	}

	& .totalPoints {
		color: #6b7280;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}
}

.studentAnswerContainer {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	width: 100%;
	height: 100%;
}

.topControlContainer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	gap: 0.5rem;
}

.topControlContainer:has(> :only-child) {
	justify-content: center;
}

.sideBlock {
	max-width: 200px;
	display: flex;
	width: 100%;
}

.topCarouselControlContainer {
	display: flex;
	align-items: center;
	gap: 0.3125rem;

	& .carouselButton {
		width: 36px;
		height: 36px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}

	& .carouselIndexInput {
		padding: 0;
		max-width: 80px;
	}

	& :global(.MuiOutlinedInput-root) {
		padding: 0;
	}

	& .totalPoints {
		color: #333333;
		font-size: 0.875rem;
		line-height: 1.6;
		font-weight: 400;
	}
}

.imagePreviewContainer {
	min-height: 180px;
}

.imagePreviewWrapper {
	max-width: 320px;
	aspect-ratio: 16/9;
	width: 100%;
	border: 1px solid #d0d0d0;
	border-radius: 15px;
}

.fullScreenButton {
	position: absolute;
	top: 8px;
	right: 8px;

	border: 0.63px solid #8c8c8c;
	background-color: #fff;
	width: 24px;
	height: 24px;
	color: #333333;
	border-radius: 4px;
	flex-shrink: 0;
}

.bottomCarouselControlContainer {
	display: flex;
	align-items: stretch;
	justify-content: center;
	gap: 0.5rem;
	height: 65px;

	& .carouselButton {
		height: 100%;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}
}

.thumbnailButton {
	border-radius: 6px;
	aspect-ratio: 4/3;
	max-width: 80px;
	width: 100%;
	border: 2px solid transparent;

	&.selected {
		border: 2px solid #c3a6f1;
	}
}

.thumbnailImage {
	aspect-ratio: 1/1;
	flex-shrink: 0;
}

.imageGrid:global(.MuiImageList-root) {
	max-height: 400px;
	height: 100%;
	min-height: 235px;
	padding: 0.5rem;
}

.imgGridContainer {
	border-radius: 15px;
	border: 1px solid #d0d0d0;
	aspect-ratio: 1/1;
	position: relative;
}

.imgGridFallbackContainer,
.imgGridImageWrapper {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 0.5rem;
	box-sizing: border-box;
}

.imageContainer {
	display: flex;
	width: 100%;
	height: 100%;
	background-color: #212121;
	flex-grow: 1;
	overflow: auto;
}

.fsImagePreviewWrapper {
	margin: auto;
	height: 100%;
	justify-content: flex-start;
	align-items: flex-start;
	width: fit-content;
	height: fit-content;
}

.fsImageWrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.fsImage {
	max-width: 80vw;
	max-height: 70vh;
	transition: transform 0.2s ease;
}

.carouselDialogContent:global(.MuiDialogContent-root) {
	padding: 0;
	display: flex;
	place-content: center;
	overflow: hidden;
	flex-direction: column;
	gap: 1rem;
}

.fullScreenTopRow {
	display: grid;
	grid-template-columns: 1fr auto 1fr;
	align-items: center;
	width: 100%;
	margin-top: 2rem;
	padding: 0 1rem;
	box-sizing: border-box;
	flex-shrink: 0;
}

.fullScreenCarouselControlContainer {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	height: 100%;

	& .carouselButton {
		border: 1px solid #8c8c8c;
		background: #282828;
		border-radius: 4px;
		width: 36px;
		height: 36px;
	}

	& .carouselIndexInput {
		padding: 0;
		max-width: 80px;

		& :global(.MuiOutlinedInput-root) {
			padding: 0;
		}
	}

	& .totalPoints {
		color: #fff;
		font-weight: 400;
		font-size: 0.9375rem;
		line-height: 1.5;
	}
}

.buttonRow {
	display: flex;
	align-items: center;
	gap: 0.5rem;
}

.buttonRow:last-child {
	justify-content: flex-end;
}

.fsButton {
	border: 1px solid #8c8c8c;
	background: #282828;
	border-radius: 4px;
}

.fsFallbackText:global(.MuiTypography-root) {
	color: #fff;
	font-size: 1.5rem;
	line-height: 1.6;
	font-weight: 400;
}

@media (max-width: 768px) {
	.topControlContainer {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.studentAnswerContainer.studentAnswerContainer {
		padding: 0.5rem;
	}

	.fullScreenTopRow.fullScreenTopRow {
		margin-top: unset;
		grid-template-columns: 1fr;
		row-gap: 0.75rem;

		& .buttonRow {
			width: 100%;
			justify-content: center;
		}
	}

	.fullScreenCarouselControlContainer {
		width: 100%;
		justify-content: center;
	}

	.gradingContainer {
		flex-direction: column;
		justify-content: unset;
		align-items: flex-start;
	}
}
